module.exports = __webpack_public_path__ + "static/media/Саматов Б.Т., Akbarov A.Kh..7765143c.pdf";